import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { getPatternCategoryProperties } from 'shared-lib'

@Component({
  selector: 'c-job-pattern',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule],
  template: `
    <div
      class="e11-text-white e11-rounded-md"
      [ngClass]="{
        'e11-text-sm e11-px-5 e11-py-2 e11-font-primary-demibold': size == 'md',
        'e11-text-xs e11-px-4 e11-py-1.5': size == 'sm',
        '!e11-skeleton !e11-animate-pulse !e11-text-transparent': loading
      }"
      [style.background-color]="candidatePattern?.color"
      [style.color]="candidatePattern?.textColor"
    >
      {{ candidatePattern?.pattern }}
    </div>
  `,
})
export class CJobPatternComponent {
  _cJobPattern?: string = ''
  @Input() set cJobPattern(value: string | undefined) {
    if (value) {
      this._cJobPattern = value
      this.candidatePattern = getPatternCategoryProperties(this._cJobPattern)
    }
  }
  @Input() size: 'md' | 'sm' = 'md'
  @Input() loading: boolean = false

  candidatePattern = getPatternCategoryProperties(this._cJobPattern)
}
